import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { RolePermissionEnum } from '../service/dto';

@Directive({
	selector: '[hasPermission]',
	standalone: false
})
export class HasPermissionDirective {
	private state = false;

	constructor(private templateRef: TemplateRef<any>,private viewContainer: ViewContainerRef,private authService: AuthService) { }

	@Input()
	set hasPermission(requiredPermissions: RolePermissionEnum[]) {
		const userPerms = this.authService.authState?.agent?.appRole?.permissions?.filter(i=>i.selected == true).map(i=>i.permission) ?? [];

		const before = this.state;
		this.state=requiredPermissions.some(p => userPerms.includes(p));

		if(before == this.state){
			return;
		}
		if(before ==  true){
			this.viewContainer.clear();
		}else{
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
